var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.externalSize && _vm.apertureSize && _vm.colour
    ? _c("mount-visualisation", {
        attrs: {
          "external-length": _vm.externalSize.length,
          "external-width": _vm.externalSize.width,
          "aperture-length": _vm.apertureSize.length,
          "aperture-width": _vm.apertureSize.width,
          "aperture-offset-top": _vm.topBorder,
          "aperture-offset-left": _vm.leftBorder,
          "mount-colour": _vm.colour,
          "board-thickness": _vm.thickness,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }